/**
 * Configuration et données pour le composant Navbar
 */

// Couleurs de l'application
export const colors = {
  wonPink: "#ed4c67",
  wonBlue: "#3498db",
  wonLight: "#ecf0f1",
  wonDark: "#34495e",
  wonBlack: "#131313"
};

// Configuration des liens de navigation
export const navLinks = [
  { href: 'index.html', text: 'Accueil', index: 0, active: true },
  { href: 'index.html#services', text: 'Services', index: 1 },
  { href: 'index.html#formations', text: 'Formations', index: 2 },
  // { href: '#about', text: 'À propos', index: 3 },
  { href: 'blog.html', text: 'Blog', index: 4 }
];

// Configuration des réseaux sociaux
export const socialLinks = [
  { 
    icon: 'M18.244 2h3.86l-8.4 9.607L23 22h-7.156l-5.59-6.524L4.4 22H.54l8.793-10.053L1 2h7.156l5.237 6.114L18.244 2Zm-2.18 18.4h2.3L7.747 3.6H5.4l10.664 16.8Z', 
    href: 'https://x.com/' 
  },
  { 
    icon: 'M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z', 
    href: 'https://facebook.com/' 
  },
  { 
    icon: 'M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z', 
    href: 'https://linkedin.com/' 
  }
];

// Noms des classes CSS pour les différents états
export const cssClasses = {
  navbarHidden: 'transform -translate-y-full',
  navbarVisible: 'transform translate-y-0',
  mobileMenuOpen: 'h-screen',
  mobileMenuClosed: 'h-0',
  hamburgerActive: {
    bar1: 'rotate-45 translate-y-0',
    bar2: 'opacity-0 translate-x-full',
    bar3: '-rotate-45 translate-y-0'
  },
  hamburgerInactive: {
    bar1: '-translate-y-2',
    bar2: '',
    bar3: 'translate-y-2'
  }
};

// Sélecteurs pour les sections importantes de la page
export const sections = ['#', '#services', '#formations', '#about', '#blog'];
